module.exports = "/packs/images/svg/accessibility/poolside_facility~774ad22aa436f3932420f6a66df1e09e.svg";